<template>
    <section v-if="brokerWebContext.restricted && brokerWebContext.error" class="broker-web-notice" role="alert">{{ t('brokerWeb.reopen') }}</section>
    <template v-else>
      <router-view/>
      <p v-if="brokerWebContext.restricted && brokerWebContext.completed" class="broker-web-notice" role="status">{{ t('brokerWeb.finished') }}</p>
    </template>
</template>
<script setup>
import { setCookie, getToken, getDeviceId, removeCookie,
  ClientPlatformKey,
  TokenKey,
  DeviceIdKey,
  DeviceInfoKey,
  LanguageKey,
  UserInfoKey } from '@/utils/cookies';
import { onMounted } from 'vue'
import { changeLanguage } from '@/utils/setLang'
import { brokerWebContext, isBrokerWebAuthorization } from '@/utils/brokerWebAuthorization'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

// ensureBridgeReady 受限浏览器入口不读取或持久化 App 登录态。
async function ensureBridgeReady() {
    if (isBrokerWebAuthorization()) return
    // 通常在页面加载完成后即可调用，也可轮询对象是否存在
    if (window.flutter_inappwebview) {
        // 原生 App WebView 使用 app 登录槽位，启动时清理 AppWeb 平台标记，避免请求误带 X-Platform。
        removeCookie(ClientPlatformKey);
        await Promise.all([
          fetchToken(),
          fetchLanguage(),
          fetchDeviceInfo(),
          fetchDeviceId(),
          fetchUserInfo()
        ]);
    }else{
      // Bridge not ready yet
        console.warn('Bridge not ready yet');
    }

    
  }
  // 获取token
  async function fetchToken() {
    const res = await window.flutter_inappwebview.callHandler('getToken');
    setCookie(TokenKey, res?.token || '');
  }
  // 获取设备信息
  async function fetchDeviceInfo() {
    const res = await window.flutter_inappwebview.callHandler('getDeviceInfo');
    const info = JSON.parse(res?.deviceInfo || '{}');
    // toast.show('device info:' + JSON.stringify(info))
    setCookie(DeviceInfoKey, JSON.stringify(info));
  }
  // 获取设备id
  async function fetchDeviceId() {
    const res = await window.flutter_inappwebview.callHandler('getDeviceId');
    setCookie(DeviceIdKey, res?.uniqueId || '');
  }
  // 获取当前语言
  async function fetchLanguage() {
    // /join 注册页语言只按 URL lang > 浏览器语言 > US，避免 App 注入语言覆盖外部访客语言。
    if (window.location?.pathname === '/join') {
      return;
    }
    const res = await window.flutter_inappwebview.callHandler('getLanguage');
    setCookie(LanguageKey, res?.language || 'US');
    changeLanguage(res?.language || 'US');  
  }
  // 获取用户信息
  async function fetchUserInfo() {
    const res = await window.flutter_inappwebview.callHandler('getUserInfo');
    const userInfo = res?.userInfo || {};
    console.log('userInfo:', userInfo || null);
    setCookie(UserInfoKey, JSON.stringify(userInfo));
  }
  ensureBridgeReady();
  // onMounted(async () => {
  //   await ensureBridgeReady();
  // })


</script>
<style lang="less">
    @import './assets/css/main.css';
    @import './assets/css/flex.less';
</style>
